<template>
  <Modal
    actions
    name="UPDATE_OBSERVATIONS_APPOINTMENT_MODAL"
    :title="$t('appointment.adminActions.updateObservations.action')"
    ref="updateAppointmentObservationsModal"
  >
    <template v-slot:body>
      <v-progress-linear
        v-if="isAppointmentLoading"
        class="mt-5 mb-7"
        indeterminate
        rounded
      />

      <div v-show="!isAppointmentLoading">
        <AppointmentFormDetails :appointment="appointment" />

        <v-form ref="appointmentUpdateObservations" lazy-validation>
          <v-textarea
            :label="$t('appointment.reschedule.observation')"
            v-model="observations"
            hide-details
            outlined
            rows="3"
          />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="validate"
        :loading="loading"
        :disabled="disabled"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.adminActions.updateObservations.action') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Modal from '@/components/app/Modal'

import AppointmentFormDetails from './formFieldsReschedule/AppointmentFormDetails'

export default {
  name: 'AppointmentUpdateObservations',

  components: {
    Modal,
    AppointmentFormDetails,
  },

  data() {
    return {
      loading: false,
      disabled: false,
      userObservations: null,
      message: '',
    }
  },

  computed: {
    ...mapGetters(['appointment', 'isAppointmentLoading']),

    observations: {
      get() {
        this.userObservations = this.appointment?.observations
        return this.appointment?.observations
      },

      set(newObservations) {
        this.userObservations = newObservations
      },
    },
  },

  methods: {
    ...mapActions([
      'updateAppointmentObservationsAsAdmin',
    ]),

    validate() {
      if (this.$refs.appointmentUpdateObservations.validate()) {
        this.loading = true

        const payload = {
          appointment_id: this.appointment.id,
          observations: this.userObservations,
        }

        this.updateAppointmentObservationsAsAdmin(payload)
          .then(() => {
            if (this.$parent?.refreshMap) this.$parent?.refreshMap()
            if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
          })
          .then(() => this.closeAllModals())
          .then(() => this.$refs?.appointmentUpdateObservations?.reset())
          .finally(() => this.loading = false)
      }
    },

  },
}
</script>
